class VideoPlayer {
  constructor(videoSelector, buttonSelector) {
    this.videos = document.querySelectorAll(videoSelector);
    this.playButtons = document.querySelectorAll(buttonSelector);
    this.hideTimeouts = {};

    if (this.videos.length > 0 && this.playButtons.length > 0) {
      this.init();
    }
  }

  init() {
    this.playButtons.forEach((button, index) => {
      button.addEventListener("click", () => this.togglePlay(index));
    });

    this.videos.forEach((video, index) => {
      video.addEventListener("click", () => this.togglePlay(index));
    });
  }

  togglePlay(index) {
    const video = this.videos[index];
    const button = this.playButtons[index];

    if (video.paused) {
      video.play();
      button.textContent = "⏸";
      button.classList.remove("paused");
      button.classList.add("playing");
      clearTimeout(this.hideTimeouts[index]);

      this.hideTimeouts[index] = setTimeout(() => {
        button.style.opacity = "0";
      }, 500);
    } else {
      video.pause();
      button.textContent = "▶"; 
      button.classList.remove("playing");
      button.classList.add("paused");
      button.style.opacity = "1";
      clearTimeout(this.hideTimeouts[index]);
    }
  }
}
document.addEventListener("DOMContentLoaded", function () {
  new VideoPlayer(".video-class", ".playBtn");
});


